import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { useGeneratePdf } from '@src/orders/hooks/useGeneratePdf';
import { useTranslation } from 'react-i18next';

type Props = {
  order: OrderListing;
};
export const GeneratePdfAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();

  const { generatePdf } = useGeneratePdf({
    orderId: order.id,
    onSuccess: () => {
      showSuccessToast(t('orderSummary.generatePdf.success'));
    },
    onError: () => {
      showErrorToast(t('orderSummary.generatePdf.error'));
    },
  });

  const handleGeneratePdf = () => {
    generatePdf();
  };

  return (
    order.canDo(OrderActions.GENERATE_PDF) && (
      <>
        <MenuItem key={`${order.id}-generate-pdf`} onClick={handleGeneratePdf}>
          {t('generateOrderPdf')}
        </MenuItem>
      </>
    )
  );
};
